import FullPageMessage from "./FullPageMessage";

const AppCrashFallback = () => (
  <FullPageMessage
    title="Algo salió mal"
    description="Recargá la página para seguir."
    actionLabel="Recargar"
    onAction={() => window.location.reload()}
  />
);

export default AppCrashFallback;
